var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('div', {
    staticClass: "title-rounded mb-30px mb-md-60px",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('h2', {
    staticClass: "tit white--text"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }